import React, { Component } from 'react'
import _ from 'lodash'
import { Grid, Row, Col, ButtonToolbar, FormGroup, ControlLabel } from 'react-bootstrap'
import Toggle from 'react-toggle'
import NKIcon from '@norkart/ikoner'
import NkaButton from 'nka-button'
import NkaSelect from 'nka-select'
import Validation from 'react-validation'

import ModalImageCapture from '../../felles/Bilder/modal-image-capture'

import 'nka-button/dist/style.css'
import 'nka-select/dist/style.css'
import '../../felles/valideringsRegler'
import 'react-toggle/style.css'
import './vannmaaler.css'

export default class Nymaaler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            bildeAvMaaler: [],
            taBilde: false,
            plombert: this.props.maalerInfo === null ? true : this.props.maalerInfo.Plombert,
            retning: '',
            type: '',
            fabrikat: '',
            dimensjon: '',
            stand: this.props.maalerInfo === null ? '0' : this.props.maalerInfo.Stand,
            maalernummer:
                this.props.maalerInfo === null ? '' : this.props.maalerInfo.Maalernummer,
            antallSiffer: '',
            fjernavlest: this.props.maalerInfo === null ? false : this.props.maalerInfo.Fjernavlest,
            vannmaalertype: '',
            maalernummerPrefix: '',
            maalerType: null,
            loraEuid: ''
        }

        this._ferdig = this._ferdig.bind(this)
        this._avbryt = this._avbryt.bind(this)

        this._taBildeAvMaaler = this._taBildeAvMaaler.bind(this)
        this._bildeTatt = this._bildeTatt.bind(this)
        this._handlePlombertEndret = this._handlePlombertEndret.bind(this)
        this._handleFjernavlestEndret = this._handleFjernavlestEndret.bind(this)
        this._endretVerdi = this._endretVerdi.bind(this)
        this._slettBilde = this._slettBilde.bind(this)
        this._lagBildeElmement = this._lagBildeElmement.bind(this)
    }

    componentDidMount() {
        let valgtType = _.filter(this.props.Vannmaalertyper, type => type.Id > 0)[0]

        this.setState({
            maalerType: valgtType,
            fabrikat: valgtType.FabrikatTekst,
            antallSiffer: valgtType.Antallsiffer,
            dimensjon: valgtType.DimensjonTekst,
            retning: valgtType.RetningTekst,
            vannmaalertype: valgtType.TypeTekst,
            temperatur: valgtType.Temperatur,
            maalernummerPrefix: valgtType.MaalernummerPrefix
        })
    }

    _taBildeAvMaaler() {
        this.setState({
            taBilde: !this.state.taBilde
        })
    }

    _bildeTatt(image, tekst) {
        var bilder = this.state.bildeAvMaaler

        let bildeObj = {
            Id: bilder.length,
            Bilde: image,
            Kommentar: tekst ? tekst : 'Installert måler'
        }

        bilder.push(bildeObj)

        this.setState({
            bildeAvMaaler: bilder,
            taBilde: false
        })
    }

    _endretVerdi(event) {
        const name = event.target.name
        const value = event.target.value

        if (name === 'type') {
            let valgtTypeId = parseInt(value, 10)
            let valgtType = _.filter(this.props.Vannmaalertyper, type => type.Id === valgtTypeId)[0]

            this.setState({
                [name]: value,
                maalerType: valgtType,
                fabrikat: valgtType.FabrikatTekst,
                antallSiffer: valgtType.Antallsiffer,
                dimensjon: valgtType.DimensjonTekst,
                retning: valgtType.RetningTekst,
                vannmaalertype: valgtType.TypeTekst,
                maalernummerPrefix: valgtType.MaalernummerPrefix ? valgtType.MaalernummerPrefix : ''
            })
        }

        this.setState({
            [name]: value
        })
    }

    _ferdig = event => {
        event.preventDefault()
        let maalerNummer = this.state.maalernummerPrefix ? this.state.maalernummerPrefix + this.state.maalernummer : this.state.maalernummer
        this.props.onClose(
            this.state.bildeAvMaaler,
            this.state.stand,
            maalerNummer,
            this.state.plombert,
            this.state.maalerType,
            this.state.fjernavlest,
            this.state.loraEuid
        )
    }

    _avbryt() {
        this.props.onClose(null, '')
    }

    _handlePlombertEndret(event) {
        this.setState({
            plombert: event.target.checked
        })
    }

    _handleFjernavlestEndret(event) {
        this.setState({
            fjernavlest: event.target.checked
        })
    }

    _slettBilde(id) {
        var bilder = this.state.bildeAvMaaler

        var oppdatert = _.filter(bilder, function (bilde) {
            return bilde.Id !== id
        })

        this.setState({
            bildeAvMaaler: oppdatert
        })
    }

    _lagBildeElmement(bilde) {
        if (bilde.Bilde) {
            return (
                <Col xs={12} key={bilde.Id}>
                    <div className="bilde">
                        <img src={bilde.Bilde} width="150" height="100" alt={bilde.Kommentar} />
                        <button
                            className="delete-button"
                            onClick={() => this._slettBilde(bilde.Id)}
                        >
                            <NKIcon icon="soppelbotte" size="1" color="nk-black" />
                        </button>
                    </div>
                </Col>
            )
        }
    }

    render() {
        var bilder = _.map(this.state.bildeAvMaaler, this._lagBildeElmement)

        return (
            <Grid>
                <Row>
                    <Col xs={12}>
                        <NkaButton icon="kamera" onClick={this._taBildeAvMaaler}>
                            Ta bilde
                        </NkaButton>
                    </Col>
                </Row>

                {this.state.taBilde && (
                    <ModalImageCapture visBilekommentar={true} onClose={this._bildeTatt} />
                )}
                <Row>{this.state.bildeAvMaaler.length > 0 && bilder}</Row>
                <Validation.components.Form ref={c => (this.form = c)} onSubmit={this._ferdig}>
                    <Row>
                        <Col xs={12} sm={12} md={2}>
                            <FormGroup>
                                <ControlLabel style={{ paddingTop: 15 + 'px' }}>
                                    Stand*
                                </ControlLabel>
                                <Validation.components.Input
                                    className="hoeyde48"
                                    name="stand"
                                    errorClassName="is-invalid-input"
                                    type="number"
                                    pattern="\d*"
                                    placeholder="Ny stand"
                                    value={this.state.stand}
                                    onChange={this._endretVerdi}
                                    validations={['required', 'numeric', 'storreEllerLikNull']}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12}>
                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <br />
                                <NkaSelect id="type" name="type" onChange={this._endretVerdi}>
                                    {_.map(this.props.Vannmaalertyper, function (o, i) {
                                        return (
                                            <option key={i} value={o.Id}>
                                                {o.Tekst}
                                            </option>
                                        )
                                    })}
                                </NkaSelect>



                            </FormGroup>
                            {/* <p className="marginTopMinus10">{this.state.vannmaalertype}</p> */}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={2}>
                            <FormGroup>
                                <ControlLabel>Målernummer*</ControlLabel>
                                <Validation.components.Input
                                    className="hoeyde48"
                                    name="maalernummer"
                                    errorClassName="is-invalid-input"
                                    pattern="\d*"
                                    type="number"
                                    placeholder="Målernummer"
                                    value={this.state.maalernummer}
                                    onChange={this._endretVerdi}
                                    validations={['required', 'numeric', 'storreEllerLikNull']}
                                />
                            </FormGroup>
                            {
                                this.state.maalernummerPrefix && <p>{this.state.maalernummerPrefix}{this.state.maalernummer}</p>
                            }

                            {(this.state.maalerType && this.state.maalerType.BrukerLora) &&  <FormGroup>
                                <ControlLabel>Kommunikasjon</ControlLabel>
                                <br />
                                <input
                                    className="hoeyde48"
                                    name="loraEuid"
                                    type="text"
                                    placeholder="Lora EUID"
                                    onChange={this._endretVerdi}
                                    value={this.state.loraEuid}
                                /></FormGroup>}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12}>
                            <FormGroup>
                                <ControlLabel>Plombert</ControlLabel>
                                <br />
                                <Toggle
                                    defaultChecked={this.state.plombert}
                                    onChange={this._handlePlombertEndret}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={10} sm={8} md={8}>
                            <FormGroup>
                                <ControlLabel>Fjernavleses</ControlLabel>
                                <br />
                                <Toggle
                                    defaultChecked={this.state.fjernavlest}
                                    onChange={this._handleFjernavlestEndret}
                                />


                            </FormGroup>
                        </Col>
                    </Row>
                    <ButtonToolbar>
                        <Validation.components.Button className="btn btn-default hoeyde48">
                            OK
                        </Validation.components.Button>
                    </ButtonToolbar>
                </Validation.components.Form>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/nymaaler.jsx